import { useState } from "react";
import {ethers, BigNumber} from 'ethers';
import { Box, Button, Flex, Input, Text, Image } from '@chakra-ui/react';
import Claim from "./assets/social-media-icons/claimbutt.png";
import Mint from "./assets/social-media-icons/mintbutt.png";


import Pooplicator from './Pooplicator.json';

const pooplicatorAddress = "0x9968A20c6F63467511a95AD7d5c8ef275273ba34";


const MainMint = ({accounts, setAccounts}) => {
    const [mintAmount, setMintAmount] = useState(1);
    const isConnected = Boolean(accounts[0]);

    async function handleMint(){
        console.log("handleMint called"); // Add this line

        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider. getSigner();
            const contract = new ethers.Contract(
                pooplicatorAddress,
                Pooplicator.abi,
                signer
            );
            try {
                const response = await contract.mint(BigNumber.from(mintAmount),{
                    value: ethers.utils.parseEther((0.003 * mintAmount).toString()),
                });
                console.log('response: ', response);
            }catch (err) {
                console.log("error",err);
            }
        } 
    }  

    async function handleClaim(){
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider. getSigner();
            const contract = new ethers.Contract(
                pooplicatorAddress,
                Pooplicator.abi,
                signer
            );
            try {
                const response = await contract.claim();
                console.log('response: ', response);
            }catch (err) {
                console.log("error",err);
            }
        } 
    }  

    const handleDecrement = () => {
        if(mintAmount <= 1) return;
        setMintAmount(mintAmount -1);
    }
    const handleIncrement = () => {
        if(mintAmount >= 10) return;
        setMintAmount(mintAmount + 1);
    };

    return (
        <Flex justify="center" align="center" height="100vh" paddingBottom="150px" paddingTop="250px">
            <Box width="520px">
            <div>
                {/* <Text fontSize="48px" textShadow="0 5px #000000">
                    Pooplicators
                </Text>
                <Text fontSize="30px" letterSpacing="-5.5%" fontFamily="VT323" textShadow="0 2px 2px #000000">
                    Not a Sock Machine. Mint to find out
                </Text> */}
            </div>
            {isConnected ? (
                <div>
                        <Button 
                        borderRadius="5px"
                        boxShadow= "0px 2px 2px 1px #OFOFOF"
                        color="white"
                        cursor="pointer"
                        fontFamily="inherit"
                        onClick={handleClaim}>

                        <Image src={Claim} boxSize="82px" width="100" />

                    </Button>
                    <Flex align="center" justify="center">
                        <Button 
                        backgroundColor="#D6517D"
                        borderRadius="5px"
                        boxShadow= "0px 2px 2px 1px #OFOFOF"
                        color="white"
                        cursor="pointer"
                        fontFamily="inherit"
                        padding="15px"
                        marginTop="10px"
                        onClick = {handleDecrement}>
                            -
                        </Button>
                       
                        <Input
                        readOnly
                        fontFamily="inherit"
                        width="100px"
                        height="40px"
                        textAlign="center"
                        paddingLeft="19px"
                        marginTop="10px"
                        type="number"
                        value= {mintAmount}/>

                        <Button 
                        backgroundColor="#D6517D"
                        borderRadius="5px"
                        boxShadow= "0px 2px 2px 1px #0F0F0F"
                        color="white"
                        cursor="pointer"
                        fontFamily="inherit"
                        padding="15px"
                        marginTop="10px"
                        onClick = {handleIncrement}>+</Button>

                    </Flex>
                
                    <Button 
                        borderRadius="5px"
                        boxShadow= "0px 2px 2px 1px #OFOFOF"
                        color="white"
                        cursor="pointer"
                        fontFamily="inherit"
                        padding="15px"
                        marginTop="10px"
                        onClick={handleMint}>
                        <Image src={Mint} boxSize="82px" width="100" />
                    </Button>
                
                </div>
            ):(
                <p>Connect Wallet to mint. Mint Price: .003 eth. Holders can click the claim button. Claim button will mint as many as you hold in the wallet that you are minting from. Anyone can mint up to 10. Public Sale and Claim Period will both be live at the same time. FCFS</p>
            )}
            </Box>
        </Flex>
    );
};

export default MainMint;